import { Injectable, OnDestroy } from '@angular/core';
import { IonicUtilityService } from '../ionic/ionic-utility.service';
import { PluginListenerHandle } from '@capacitor/core';
import { NetworkStatus, Network } from '@capacitor/network';
import { OfflineModalComponent } from '@viso/core/ui/offline-modal';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService implements OnDestroy {
  private networkListener: PluginListenerHandle;
  private noInternetModalInstance = null;
  lastConnectionType: string;
  private networkStatus = new Subject<NetworkStatus>();
  networkStatusChange$ = this.networkStatus.asObservable();

  constructor(
    private ionicUtility: IonicUtilityService,
    private router: Router,
    private platform: Platform,
    private nav: NavController,
    ) {
    this.ionicUtility.triggerModal();
  }

  popstate = () => {
    history.go(1);
  }

  disableBackButton = () => {
    history.pushState(null, null, location.href);
    window.addEventListener('popstate', this.popstate);
  };

  connectionStatusUpdate = async ({ connected, connectionType }) => {
    this.networkStatus.next({ connected, connectionType });
    if (
      connectionType !== 'none' &&
      this.lastConnectionType !== connectionType
    ) {
      this.lastConnectionType = connectionType;
      if (this.noInternetModalInstance) {
        await this.noInternetModalInstance.dismiss();
        this.noInternetModalInstance = null;
        // this.refreshCurrentRoute();
        if (this.ionicUtility.isNative) {
          this.platform.backButton.observers.pop();
        } else {
          history.back();
          window.removeEventListener('popstate', this.popstate, false);
        }
      }
    }
    if (!connected && this.lastConnectionType !== connectionType) {
      this.lastConnectionType = connectionType;
      if (this.noInternetModalInstance === null) {
        if (this.ionicUtility.isNative) {
          this.platform.backButton.subscribeWithPriority(1, () => { });
        } else {
          this.disableBackButton();
        }
        // TODO: This is hack to retrieve current active view injector object 
        const injector = this.nav['topOutlet'].stackCtrl.activeView.ref.injector;
        const ionic = injector.get(IonicUtilityService);
        this.noInternetModalInstance = await ionic.displayModal(
          OfflineModalComponent,
          null,
          null
        );
      }
    }
  }

  async initializeNetworkMonitor() {
    const status = await Network.getStatus();
    this.lastConnectionType = status.connectionType;
    this.networkListener = await Network.addListener(
      'networkStatusChange',
      this.connectionStatusUpdate
    );
    setInterval(async () => {
      const status = await Network.getStatus();
      this.lastConnectionType = status.connectionType;
      this.connectionStatusUpdate(status);
    }, 10000);
  }

  async refreshCurrentRoute() {
    // this.router.onSameUrlNavigation ='reload';
    // await this.router.navigate([this.router.url])
    // this.router.onSameUrlNavigation ='ignore';
    // const redirectTo = this.router.url;
    // await this.router.navigateByUrl('reload', { state: { redirectTo }, skipLocationChange: true });
    // setTimeout(async () => {
    //   await this.router.navigate([redirectTo], { replaceUrl: true });
    // }, 5000)
    // const defaltOnSameUrlNavigation = this.router.onSameUrlNavigation;
    // this.router.onSameUrlNavigation = 'reload';
    setTimeout(async () => {
      await this.router.navigate([this.router.url]);
    },5000)
    // this.router.onSameUrlNavigation = defaltOnSameUrlNavigation;
  }

  ngOnDestroy(): void {
    this.networkListener.remove();
  }
}

